import './Loader.css';

import React from 'react';

const Loader = (props: any) => {
  const { show } = props;
  return (
    <div className={`loader ${show ? 'show' : ''}`}>
      <svg
        width="102"
        height="98"
        viewBox="0 0 102 98"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          id="loader-1-1"
          d="M18.0002 60.0132V60.0131C18.0002 59.766 18.1028 59.5164 18.3061 59.322C18.5101 59.1268 18.7985 59.0054 19.1123 59H38.866C39.185 59 39.48 59.1201 39.6888 59.317L40.375 58.5897L39.6888 59.317C39.8956 59.5121 40 59.7639 40 60.0132V78.9868C40 79.2361 39.8956 79.4879 39.6888 79.683C39.48 79.8799 39.185 80 38.866 80H36.7961C31.7586 79.9432 26.9601 78.01 23.4434 74.6384C19.9273 71.2674 17.978 66.7343 18.0002 62.0311H18.0002V62.0264V60.0132Z"
          stroke="#59358C"
          strokeWidth="2"
        />
        <mask
          id="mask0_233_618"
          maskUnits="userSpaceOnUse"
          x="7"
          y="51"
          width="40"
          height="40"
        >
          <circle cx="27" cy="71" r="20" fill="#59358C" />
        </mask>
        <g mask="url(#mask0_233_618)" id="loader-1">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.1049 58C18.5441 58.0072 18.0088 58.2226 17.6149 58.5993C17.221 58.9761 17.0001 59.484 17.0002 60.0132V62.0264C16.9767 67.0129 19.044 71.8059 22.7513 75.3602C26.4586 78.9145 31.5052 80.9418 36.7905 81H38.866C39.432 81 39.9748 80.7879 40.375 80.4104C40.7752 80.0328 41 79.5207 41 78.9868V60.0132C41 59.4793 40.7752 58.9672 40.375 58.5897C39.9748 58.2121 39.432 58 38.866 58H19.1049Z"
            fill="#59358C"
          />
        </g>
        <path
          id="loader-2-2"
          d="M61.1637 37.007H61.1308H28.4435C25.0916 37.2316 21.9191 38.5255 19.4287 40.6764L19.3997 40.7015L19.3688 40.7242L13.0395 45.3946H49.1715H49.1725V46.3946C49.6912 46.3936 50.2038 46.5015 50.6744 46.711C51.145 46.9204 51.5622 47.2262 51.8969 47.6069L61.1637 37.007ZM61.1637 37.007L61.1965 37.0049C61.7069 36.9713 62.2076 37.1126 62.6111 37.3948C62.7556 37.586 62.8621 37.7989 62.9267 38.023C63.0007 38.2796 63.0188 38.5474 62.9803 38.8103L62.9698 38.8824V38.9552V70.2731C62.7248 73.4627 61.3904 76.4918 59.1649 78.8882L59.1397 78.9154L59.1165 78.9443L54.1586 85.1472V50.3751C54.1748 49.7058 54.0376 49.0424 53.7583 48.4324C53.4876 47.8413 53.0906 47.3158 52.5964 46.8891L61.1637 37.007Z"
          stroke="#8246B8"
          strokeWidth="2"
        />
        <mask
          id="mask1_233_618"
          maskUnits="userSpaceOnUse"
          x="0"
          y="25"
          width="73"
          height="73"
        >
          <circle cx="36.5" cy="61.5" r="36.5" fill="#59358C" />
        </mask>
        <g mask="url(#mask1_233_618)" id="loader-2">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M63.3102 36.6683C62.6967 36.1914 61.9181 35.9552 61.1308 36.007H28.4105C24.8337 36.2393 21.4412 37.6169 18.7751 39.9196L10 46.3946H49.1725C49.6912 46.3936 50.2038 46.5015 50.6744 46.711C51.145 46.9204 51.5622 47.2262 51.8969 47.6069C52.3057 47.9483 52.6309 48.3724 52.8491 48.8488C53.0672 49.3251 53.1729 49.842 53.1586 50.3623V88L59.8977 79.5687C62.283 77.0002 63.715 73.7445 63.9698 70.3108V38.9552C64.029 38.5509 64.001 38.1393 63.8876 37.7459C63.7741 37.3524 63.5775 36.9856 63.3102 36.6683Z"
            fill="#8246B8"
          />
        </g>
        <path
          id="loader-3-3"
          d="M85.2248 16.7783L85.2323 16.7857L85.2399 16.7929C85.8103 17.3294 86.2574 17.9645 86.5583 18.6593C86.8592 19.3539 87.0086 20.0958 86.9996 20.8421L86.9995 20.8421V20.8541V61.1048C86.8197 65.3187 85.073 69.3493 82.0493 72.4887L82.0189 72.5202L81.9915 72.5543L77.4585 78.1693V28.6993V28.4515C77.4585 27.2538 76.9529 26.1182 76.0745 25.2906C75.1981 24.4649 74.0215 24.0107 72.8062 24.0107H72.514H20.0553L25.8892 19.7338L25.9189 19.712L25.9469 19.6881C29.2879 16.838 33.5929 15.175 38.1145 15H80.7827C81.6168 15 82.4409 15.1588 83.2051 15.4656C83.9691 15.7724 84.6556 16.2199 85.2248 16.7783Z"
          stroke="#A77CCD"
          strokeWidth="2"
        />
        <mask
          id="mask2_233_618"
          maskUnits="userSpaceOnUse"
          x="7"
          y="0"
          width="95"
          height="95"
        >
          <circle cx="54.5" cy="47.5" r="47.5" fill="#59358C" />
        </mask>
        <g mask="url(#mask2_233_618)" id="loader-3">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M85.9251 16.0645C85.2598 15.4118 84.4613 14.8924 83.5776 14.5376C82.6939 14.1829 81.7433 14 80.7827 14H38.0953C33.3486 14.1794 28.8194 15.9232 25.2979 18.9273L17 25.0107H72.514H72.8062C73.7749 25.0107 74.7038 25.3732 75.3888 26.0185C76.0737 26.6638 76.4585 27.539 76.4585 28.4515V28.6993V81L82.7696 73.1824C85.9624 69.8673 87.8141 65.5987 87.9995 61.1257V20.8541C88.0102 19.9658 87.8322 19.0844 87.476 18.2619C87.1197 17.4393 86.5924 16.6922 85.9251 16.0645Z"
            fill="#A77CCD"
          />
        </g>
      </svg>
    </div>
  );
};

export default Loader;
